import { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../config/firebaseConfig";

const useAuth = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser); // ユーザーをセット
      setLoading(false);    // ローディング終了
    });

    return () => unsubscribe(); // クリーンアップ
  }, []);

  return { user, loading };
};

export default useAuth;
